import AsyncStorage from '@react-native-async-storage/async-storage';

// Frontend-only demo mode. When enabled, a small interception layer in
// services/api-requests.tsx returns seeded fixtures (chargers, history,
// charger registration) instead of hitting the backend. Used to record
// self-contained customer demos without touching production data.

const STORAGE_KEY = '@meander/demo_mode';

let cached: boolean = false;
let hasLoaded: boolean = false;

type Listener = (enabled: boolean) => void;
const listeners = new Set<Listener>();

export const isDemoMode = (): boolean => cached;

export const isDemoModeLoaded = (): boolean => hasLoaded;

export const loadDemoMode = async (): Promise<boolean> => {
  try {
    const raw = await AsyncStorage.getItem(STORAGE_KEY);
    cached = raw === 'true';
  } catch (e) {
    console.warn('[demo-mode] Failed to load demo mode flag:', e);
    cached = false;
  }
  hasLoaded = true;
  return cached;
};

export const setDemoMode = async (enabled: boolean): Promise<void> => {
  cached = enabled;
  hasLoaded = true;
  try {
    await AsyncStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch (e) {
    console.warn('[demo-mode] Failed to persist demo mode flag:', e);
  }
  for (const cb of listeners) {
    try {
      cb(enabled);
    } catch (e) {
      console.warn('[demo-mode] Listener error:', e);
    }
  }
};

export const subscribeDemoMode = (cb: Listener): (() => void) => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};
